// extracted by mini-css-extract-plugin
module.exports = {"stepsGrid":"ApplicationStatus_stepsGrid__3afmv","stepNumber":"ApplicationStatus_stepNumber__3r0fa","stepNumberSelected":"ApplicationStatus_stepNumberSelected__30gon"};